<template>
  <div class="cart-date-controls">
    <v-menu
      :value="showOrderPrepDatePicker"
      :close-on-content-click="false"
      :nudge-right="40"
      transition="scale-transition"
      offset-y
      min-width="auto"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-text-field
          v-model="orderPrepSearchDate"
          label="Filter by Date"
          prepend-inner-icon="mdi-calendar"
          readonly
          clearable
          dense
          outlined
          hide-details
          v-bind="attrs"
          v-on="on"
          @click="showOrderPrepDatePicker = true"
        />
      </template>
    </v-menu>
  </div>
</template>

<script>
import { mapFields } from 'vuex-map-fields'

export default {
  name: 'OrderPrepDateControls',
  data() {
    return {}
  },
  mounted() {
    this.orderPrepSearchDate = null
  },
  computed: {
    ...mapFields('admin', ['orderPrepSearchDate', 'showOrderPrepDatePicker']),
  },
}
</script>
